var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"task-log"},[_c('div',{staticClass:"task-log__info"},[_vm._v(_vm._s(_vm._f("formattedDatetime")(_vm.props.log.date_created))+" by "+_vm._s(_vm.props.log.author))]),_c('div',{staticClass:"task-log__comment"},[_vm._v(_vm._s(_vm.props.log.comment))])])}
var staticRenderFns = []

export { render, staticRenderFns }